import { useEffect, useState } from 'react';
import { metaPixel } from '../utils/pixel';

const STORAGE_KEY = 'pagali_consent_v1';

export type ConsentValue = 'granted' | 'denied' | null;

export function useCookieConsent(): {
  consent: ConsentValue;
  grant: () => void;
  deny: () => void;
} {
  const [consent, setConsent] = useState<ConsentValue>(null);

  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY) as ConsentValue;
    if (stored === 'granted' || stored === 'denied') {
      setConsent(stored);
      if (stored === 'granted') metaPixel.grantConsent();
    }
  }, []);

  const grant = () => {
    window.localStorage.setItem(STORAGE_KEY, 'granted');
    setConsent('granted');
    metaPixel.grantConsent();
  };

  const deny = () => {
    window.localStorage.setItem(STORAGE_KEY, 'denied');
    setConsent('denied');
    metaPixel.revokeConsent();
  };

  return { consent, grant, deny };
}

export default function CookieConsentBanner() {
  const { consent, grant, deny } = useCookieConsent();

  if (consent !== null) return null;

  return (
    <div
      role="dialog"
      aria-label="Consentimento de cookies"
      style={{
        position: 'fixed',
        bottom: 16,
        left: 16,
        right: 16,
        zIndex: 9999,
        maxWidth: 540,
        marginLeft: 'auto',
        marginRight: 'auto',
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 8px 32px rgba(0,0,0,0.16)',
        padding: '20px 24px',
        fontFamily: 'inherit',
      }}
    >
      <p style={{ fontSize: 14, color: '#374151', margin: 0, lineHeight: 1.6 }}>
        Usamos cookies para melhorar a tua experiência e medir o desempenho de
        campanhas. Podes aceitar ou recusar — a tua escolha é guardada neste
        dispositivo.{' '}
        <a href="/privacidade" style={{ color: '#7c3aed', textDecoration: 'underline' }}>
          Política de Privacidade
        </a>
        .
      </p>
      <div style={{ marginTop: 16, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={deny}
          style={{
            padding: '8px 20px',
            borderRadius: 8,
            border: '1px solid #d1d5db',
            background: '#fff',
            color: '#374151',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Recusar
        </button>
        <button
          type="button"
          onClick={grant}
          style={{
            padding: '8px 20px',
            borderRadius: 8,
            border: 'none',
            background: '#7c3aed',
            color: '#fff',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Aceitar
        </button>
      </div>
    </div>
  );
}
